// removed by extract-text-webpack-plugin
module.exports = {"featured_img":"src-components-news-item----news-item-module---featured_img---3n98I","post":"src-components-news-item----news-item-module---post---Zsvc_","post_category":"src-components-news-item----news-item-module---post_category---3husl","post_title":"src-components-news-item----news-item-module---post_title---p_Y5k","post_excerpt":"src-components-news-item----news-item-module---post_excerpt---3i2tS","post_date":"src-components-news-item----news-item-module---post_date---urPI9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/news-item/news-item.module.scss
// module id = 280
// module chunks = 22846268747618 46636455185173